module.exports = __webpack_public_path__ + "static/media/padre-pio-site.11963020.jpg";